/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVolumePlus: {
  name: 'volume-plus';
  data: string;
} = {
  name: 'volume-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.838 4.316C13.16 3.37 15 4.316 15 5.943v12.334c0 1.535-1.659 2.498-2.992 1.736L6.734 17H3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3.68l5.158-3.684ZM13 5.943 7.842 9.627A2 2 0 0 1 6.68 10H3v5h3.734a2 2 0 0 1 .993.264L13 18.276V5.943ZM20 9a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
